import { Button, Tooltip, useToaster } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { DivisionMensIcon } from '@enterprise-ui/icons'
import apiConfig from '../../../config'
import { filteredItemWithStatus } from '../../../resources/searchUtills'
import { SEARCH_ACTIONS } from '../../../constants/search'
import { PRESENTATION_RESTRICY_LIFECYCLE_STATUS } from '../../../constants/search'

const PresentationAttributes = ({ selectedItems }) => {
  const toaster = useToaster()
  const selectedTcins = selectedItems?.map((item) => item.tcin, [])
  const redirectToPresentationAttributesApp = async () => {
    try {
      const presentationAttributeAppBaseUrl = `${window.location.origin}`
      const presentationAttributeDetailsUrl = `${presentationAttributeAppBaseUrl}${apiConfig.presentationAttribute.domainPath}${apiConfig.presentationAttribute.managePath}/${selectedTcins}`
      window.open(
        presentationAttributeDetailsUrl,
        '_self',
        'noopener,noreferrer',
      )
    } catch (error) {
      toaster({
        type: 'error',
        heading: 'Error Redirecting to Presentation Attribute Application',
        message:
          error.message || 'An unknown error occurred while redirecting.',
      })
    }
  }

  const isPresentationSupportStatus = filteredItemWithStatus(
    PRESENTATION_RESTRICY_LIFECYCLE_STATUS,
    selectedItems,
  )

  const ispresentationButtonDisabled =
    selectedItems?.length !== 0 &&
    selectedItems?.length <= SEARCH_ACTIONS.MAX_EDITABLE &&
    isPresentationSupportStatus?.length !== 0 &&
    selectedItems?.length === isPresentationSupportStatus?.length

  return (
    <>
      <Tooltip
        content={
          selectedItems?.length <= SEARCH_ACTIONS.MAX_EDITABLE
            ? !ispresentationButtonDisabled
              ? 'A selected item is a combination of History lifecycle status'
              : 'Manage Presentation Attributes'
            : 'Manage Presentation Attributes: Max 100'
        }
        location="top"
        data-testid="presentation-attributes-tooltip"
      >
        <Button
          type="ghost"
          onClick={redirectToPresentationAttributesApp}
          className="button-bg-hover-transparent"
          disabled={!ispresentationButtonDisabled}
          data-testid="casepack-button"
          // style={{ visibility: 'hidden' }}
        >
          <EnterpriseIcon
            icon={DivisionMensIcon}
            size="md"
            className="hc-clr-contrast-weak"
          />
        </Button>
      </Tooltip>
    </>
  )
}

export default PresentationAttributes
